import {
  Layer as MapLibreLayer,
  LayerProps as MapLibreLayerProps
} from 'react-map-gl/maplibre'

export type LayerProps = MapLibreLayerProps

export const Layer = MapLibreLayer
